import { isEligibleToAddBeneficiary } from "@common/state/organizationState";
import { sessionExperiencesState } from "@common/state/sessionExperiencesState";
import { useUserStore } from "@domains/auth/utils/useUserStore";
import { useRecoilState, useRecoilValue } from "recoil";

export const useSkipConnectBankAccount = () => {
  const [{ skippedConnectBankAccount }, setUserExperiencesState] =
    useRecoilState(sessionExperiencesState);
  const isBankAccountLinked = useUserStore(
    (state) => state.isBankAccountLinked,
  );
  const isEligibleToLinkAccount = useRecoilValue(isEligibleToAddBeneficiary);

  const skipConnectBankAccount = () => {
    setUserExperiencesState((prevState) => ({
      ...prevState,
      skippedConnectBankAccount: true,
    }));
  };

  return {
    skipConnectBankAccount,
    showConnectBankAccountBanner:
      isEligibleToLinkAccount &&
      !isBankAccountLinked &&
      !skippedConnectBankAccount,
  };
};
